'use client';

import { Tooltip, type TooltipProps } from 'antd';
import { type ReactElement, type ReactNode, useEffect, useState } from 'react';
import useMediaQuery from 'use-media-antd-query';

import { getDeviceInfo } from '~/shared/helpers/get-device-info';

type ResponsiveTooltipProps = Omit<TooltipProps, 'children' | 'title'> & {
  title: ReactNode;
  children: ReactElement;
};

const DISABLED_TOOLTIP_SIZES = ['xs', 'sm', 'md'] as const;

const ResponsiveTooltip = ({ title, children, trigger = ['hover', 'focus'], ...props }: ResponsiveTooltipProps) => {
  const colSize = useMediaQuery();
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const device = getDeviceInfo();

  useEffect(() => {
    setIsTouchDevice(window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  }, []);

  /*  const isTooltipDisabled =
    isTouchDevice || DISABLED_TOOLTIP_SIZES.includes(colSize as (typeof DISABLED_TOOLTIP_SIZES)[number]);*/
  const isTooltipDisabled = isTouchDevice || device.isMobileDevice;

  if (isTooltipDisabled) {
    return children;
  }

  return (
    <Tooltip
      color="#ffffff"
      styles={{
        container: {
          color: '#2f2837',
          border: '1px solid rgba(112, 70, 163, 0.14)',
          borderRadius: 9,
          boxShadow: '0 8px 22px rgba(62, 40, 91, 0.14)',
        },
      }}
      title={title}
      trigger={trigger}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default ResponsiveTooltip;
